import { LocalDate } from 'src/core/common/domain/date/local-date';
import { UuidGenerator } from 'src/core/common/infrastructure/uuid/uuid-generator';
import { QueueElement, QueueElementType } from 'src/core/queue/domain/queue-element';

type MarkNotificationReadQueueElementPrimitives = {
  id: string;
  created_at: string;
  type: string;
  notification_id: string;
};

export class MarkNotificationReadQueueElement extends QueueElement {
  constructor(id: string, createdAt: LocalDate, public readonly notificationId: string) {
    super(id, createdAt, QueueElementType.MARK_NOTIFICATION_READ);
    this.label = '';
    this.publicId = notificationId;
    this.errors = [];
  }

  static fromNotificationId(notificationId: string): MarkNotificationReadQueueElement {
    return new this(UuidGenerator.random(), LocalDate.now(), notificationId);
  }

  static fromPayload(payload: MarkNotificationReadQueueElementPrimitives): MarkNotificationReadQueueElement {
    return new this(payload.id, LocalDate.fromIsoString(payload.created_at), payload.notification_id);
  }

  isVisible(): boolean {
    return false;
  }

  toPrimitives(): MarkNotificationReadQueueElementPrimitives {
    return {
      id: this.id,
      created_at: this.createdAt.atom,
      type: this.type,
      notification_id: this.notificationId,
    };
  }
}
